<template>
    <div>
        <ProjectHeader></ProjectHeader>
        <MainContent></MainContent>
        <ProjectFooter></ProjectFooter>
    </div>
</template>

<script>
    import ProjectHeader from './components/Header.vue'
    import MainContent from './components/MainContent.vue'
    import ProjectFooter from './components/Footer.vue'

    export default {
        components: {
            ProjectHeader, MainContent, ProjectFooter
        }
    }
</script>

<style>
    @import './assets/css/stylesheet.css';
</style>



// WEBPACK FOOTER //
// src/App.vue